export default __webpack_public_path__ + "static/media/2.d154f061.svg";